/**
 * @fileoverview Trending topics type definitions.
 * Defines TypeScript interfaces and enums for trending topics feature
 * including examples, intents, statuses, and order updates.
 * @module helperMethods/trendingTopics/type
 */

/**
 * Represents a single trending topic example with publication status.
 */
export interface ExampleTrending {
  example: string;
  published: boolean;
}

/**
 * Dictionary of examples and answers organized by country code.
 */
export interface ExampleRecord {
  [country: string]: ExampleWithAnswer;
}

/**
 * Contains examples and their corresponding answer for a specific country.
 */
export interface ExampleWithAnswer {
  examples: ExampleTrending[];
  answer: string;
}

/**
 * Status enum for trending topics (none, currently active, or previously active).
 */
export enum TRENDING_TOPIC_STATUS {
  NONE = "NONE",
  CURRENTLY = "CURRENTLY",
  PREVIOUS = "PREVIOUS",
}

/**
 * Represents a trending intent with metadata and status.
 */
export interface TrendingIntentType {
  id: number;
  intentId: string;
  examples: string;
  status: TRENDING_TOPIC_STATUS;
  createdByAdmin: Boolean;
  order?: number;
  publishedAt?: Date;
  createdAt?: Date;
}

/**
 * Extended trending intent type with count information.
 */
export interface TrendingType extends TrendingIntentType {
  count: number;
}

/**
 * Represents an order update for sorting trending topics.
 */
export interface OrderUpdate {
  id: number;
  order: number;
}
